import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminSupport = lazy(() => import("@/pages/admin/AdminSupport"));

export const Route = createFileRoute("/admin/support")({
  component: AdminSupport,
});
